// react
import React from 'react'

// components
import { Dialog3 as Dialog } from '@st-operations/uikit/src/v1/index.js'
import Header from '_components/header/index.jsx'
import NewEntityDialog from '_components/new-entity-dialog/index.jsx'
import ListView from '_components/list-view/index.jsx'

class DataSourcesPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modalOpen: false,
    }
  }

  toggleModal = () => {
    this.setState((prevState) => ({
      modalOpen: !prevState.modalOpen,
    }))
  }

  render() {
    let { modalOpen } = this.state

    return (
      <div id="data-sources-page">
        <Header
          title="Data Sources"
          actions={[
            {
              children: 'Create New Data Source',
              onClick: this.toggleModal,
            },
          ]}
        />

        <ListView
          columns={[
            {
              key: 'name',
              link: '/data-sources/:_id',
              sortable: true,
            },
            {
              key: 'log_file.name',
              link: `/log-files/:log_file._id`,
              name: 'Log File',
              sortable: true,
            },
            {
              key: 'type',
              name: 'Type',
            },
            {
              key: 'description',
              name: 'Description',
            },
          ]}
          entities="data-sources"
          fields={['name', 'log_file.name', 'type', 'description']}
          filters={[]}
          searchable={true}
          sort_key={'name'}
          sort_dir={1}
        />
        <Dialog open={modalOpen} close={this.toggleModal}>
          <NewEntityDialog
            close={this.toggleModal}
            entities="data-sources"
            title="Enter a name for your new Data Source"
          />
        </Dialog>
      </div>
    )
  }
}

// export
export default DataSourcesPage
